import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { API_URL } from "../services/api";

import "../styles/featuredExams.css";

function FeaturedExams() {
  const [exams, setExams] = useState([]);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const response = await api.get("/exams");

      // Show only the first 6 exams
      setExams(response.data.slice(0, 6));

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className="featured-exams">

      <div className="section-header">

        <h2>Featured Exams</h2>

        <p>
          Browse our latest examination papers.
        </p>

      </div>

      <div className="exam-grid">

        {exams.map((exam) => (

          <div
            className="exam-card"
            key={exam.id}
          >

            <img
              src={
                exam.thumbnail_url
                  ? `${API_URL}${exam.thumbnail_url}`
                  : "https://via.placeholder.com/400x220?text=CompExams"
              }
              alt={exam.title}
            />

            <div className="exam-info">

              <span className="category">

                {exam.category}

              </span>

              <h3>

                {exam.title}

              </h3>

              <p>

                {exam.description
                  ? exam.description.substring(0, 90)
                  : "No description available."}

                ...

              </p>

              <div className="exam-footer">

                <span className="price">

                  {exam.is_free
                    ? "FREE"
                    : `KES ${exam.price}`}

                </span>

                <Link
                  to={`/exam/${exam.id}`}
                  className="view-btn"
                >
                  View
                </Link>

              </div>

            </div>

          </div>

        ))}

      </div>

    </section>
  );
}

export default FeaturedExams;